import { z } from "zod";

import { listSearchBaseShape, searchTextSchema } from "/src/router/searchSchemas";

export const personListSearchSchema = z.object({
  ...listSearchBaseShape,
  fullName: searchTextSchema,
  phoneNumber: searchTextSchema,
  imei: searchTextSchema,
  customizedId: searchTextSchema,
});

export type PersonListSearch = z.infer<typeof personListSearchSchema>;

export const personListSearchFields = ["fullName", "phoneNumber", "imei", "customizedId"] as const;

export type PersonListSearchField = (typeof personListSearchFields)[number];
export type PersonListSearchFormValues = Pick<PersonListSearch, PersonListSearchField>;

function createPersonSearchValues(
  getValue: (field: PersonListSearchField) => string | undefined,
): PersonListSearchFormValues {
  return personListSearchFields.reduce((values, field) => {
    values[field] = getValue(field);
    return values;
  }, {} as PersonListSearchFormValues);
}

export const emptyPersonListSearch = createPersonSearchValues(() => undefined);

export function getPersonSearchValues(search: PersonListSearch): PersonListSearchFormValues {
  return createPersonSearchValues((field) => search[field]);
}

export function getPersonSearchPatch(
  values: Partial<Record<PersonListSearchField, string | undefined>>,
): PersonListSearchFormValues {
  return createPersonSearchValues((field) => values[field] || undefined);
}
